import { Body } from "@sprout/typography.tsx";

import { Stack } from "@sprout/layout.tsx";
import type Application from "../../types/application";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Trans } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { markAsDreamJob } from "@/api/dream_job";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";
import ApplicationCard from "./application_card";

type Props = {
  application: Application;
  afterSuccess: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const DreamJobModal = ({ application, afterSuccess, open, onOpenChange }: Props) => {
  const queryClient = useQueryClient();

  const onAddDreamJob = () => {
    markAsDreamJob({
      dreamJobPath: application.dreamJobPath,
      invalidateQuery: () => queryClient.invalidateQueries({ queryKey: ["applications"] }),
      afterSuccess,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Trans
              i18nKey="applications:dream_job:modal:title"
              values={{ jobTitle: application.job_title }}
            />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="support-modal__body">
            <Stack gap="8px">
              <Stack gap="20px">
                <Body>
                  <Trans i18nKey="applications:dream_job:modal:description" />
                </Body>
                <ApplicationCard
                  application={application}
                  selected
                  onApplicationSelect={() => {}}
                  narrow
                  readOnly
                />
                <Body secondary>
                  <Trans i18nKey="applications:dream_job:modal:refresh_details" />
                </Body>
              </Stack>
            </Stack>
          </div>
        </DialogDescription>
        <DialogFooter>
          <DialogClose>
            <SecondaryButton>
              <Trans i18nKey="applications:dream_job:modal:cancel" />
            </SecondaryButton>
          </DialogClose>
          <DialogClose>
            <PrimaryButton onClick={onAddDreamJob}>
              <Trans i18nKey="applications:dream_job:modal:confirm" />
            </PrimaryButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DreamJobModal;
